import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { toast } from '@volee/ui'
import { useCallback } from 'react'

import { messages } from '../messages/index.ts'
import { auth } from '../services/auth.ts'

// The way out, in one place because two surfaces offer it and the answer cannot differ. A
// password sign-out resolves inside the app, so the hook does what leaving the page used to.

export function useSignOut(): () => Promise<void> {
  const cache = useQueryClient()
  const navigate = useNavigate()

  return useCallback(async () => {
    try {
      await auth.password.signOut({ navigate: false })
    } catch {
      // Other devices may still be signed in, and the user is the only one who can act on it.
      toast.error(messages.password.signOutPartial)
    } finally {
      // Every club and every staff row in there was read under the identity just left.
      cache.clear()
      // The literal, not `signInRoute.to`: the shell imports this, and the route imports the shell.
      await navigate({ to: '/sign-in', search: { returnTo: '/' } })
    }
  }, [cache, navigate])
}
